// Derived from durable project task records.
// Only original creator/product sources are retained; intermediate generated frames are excluded.
export const UGC_MARKETING_STUDIO_PROJECT_RECIPES = {
  'case-01': {
    skillId: 'ugc-beauty-skincare',
    prompt: {
      en: 'Use image1 as the only creator identity reference and image2 as the only product identity reference. Create one complete 8-second vertical 9:16 creator-led beauty UGC recommendation, captured like spontaneous flagship-phone footage. Preserve the creator’s exact face, short black curls, skin tone, body proportions, clothing, hands, and natural movement. Preserve exactly one raspberry-colored Rhode Peptide Lip Tint tube with its photographed silhouette, proportions, material, cap, color, logo, and label layout unchanged in every frame. Start with the creator already addressing the viewer, bring the closed product close to the lens for a clear front-label view, rotate it naturally under daylight, then return to a medium creator reaction with the same product still visible. Use ordinary-speed movement, clean hard cuts, subtle handheld drift, short autofocus and exposure settling, real shadows, quiet room tone, and product-handling sound. Speak this English copy once in a natural conversational voice: “I tried this product on camera. I kept the visible detail close to the lens. That’s my honest first impression.” Because the original product image only proves the closed tube, do not open, squeeze, dispense, swatch, or apply it, and do not invent a shade result, dose, package, efficacy claim, or second SKU. No beauty smoothing, morph, dissolve, digital zoom, duplicate product, anatomy drift, subtitle, caption, sticker, CTA, watermark, UI, or new text.',
      zh: '使用 image1 作为唯一的人物身份参考，使用 image2 作为唯一的商品身份参考。生成一支完整的 8 秒、9:16 竖屏美妆 UGC 推荐视频，像创作者用旗舰手机自然随手拍摄。严格保留人物的脸部身份、黑色短卷发、肤色、身体比例、衣着、手部和自然动作；画面中始终只有一支莓红色 Rhode Peptide Lip Tint 唇彩管，并在所有帧中保持源图所示的轮廓、比例、材质、瓶盖、颜色、Logo 与标签排版不变。开场时人物已经在对镜交流，随后将闭合商品靠近镜头，清晰展示正面标签，在自然光下轻轻转动，再回到人物中景反应，同时保持同一商品可见。使用正常速度动作、干净硬切、轻微手持漂移、短暂自动对焦和曝光调整、真实阴影、安静室内底噪和商品操作声。用自然对话语气完整说一次英文：“I tried this product on camera. I kept the visible detail close to the lens. That’s my honest first impression.” 由于原始商品图只证明闭合状态，不要打开、挤压、取液、试色或上唇，也不要虚构色号效果、剂量、包装、功效或第二件商品。禁止磨皮、变形、溶解、数字变焦、商品复制、人体漂移，也不要添加字幕、贴纸、CTA、水印、UI 或任何新文字。',
    },
    referenceImages: [
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/db0429d5-239d-45f6-8249-6c08a606f9cf.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original short-haired creator identity reference',
          zh: '原始短发创作者身份参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/00425415-7987-4430-9f65-5ab70b665644.jpg',
        slot: 'product',
        label: {
          en: 'Product',
          zh: '商品',
        },
        alt: {
          en: 'Original Rhode Peptide Lip Tint product reference',
          zh: '原始 Rhode Peptide Lip Tint 唇彩商品参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '8',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '480P',
      generateAudio: true,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '480p',
    outputSize: '496 × 864',
    createdAt: '2026-07-29',
    sourceProjectId: '1f2776a1-f223-4767-8d07-beb80f763027',
    sourceTaskId: '61270823-1eeb-48a2-9073-8bd22a5861a7',
  },
  bag: {
    skillId: 'ugc-bag-unboxing',
    prompt: {
      en: 'Use image1 as the only creator identity and body reference and image2 as the only handbag identity reference. Create a trendy 13-second vertical 9:16 street-style fashion UGC video on an elegant European city street with cobblestones, neutral stone architecture, natural daylight, and realistic shadows. Preserve the creator’s exact face, long black hair, skin tone, body proportions, red top, pale skirt, tall brown boots, jewelry, and natural movement. Ignore the unrelated brown handbag visible in the creator image. Preserve exactly one white-and-black quilted handbag from image2 with its photographed silhouette, proportions, leather material, stitching, black looped handles, chain, hardware, corner panel, and logo placement unchanged in every shot. Use quick 1–2 second smartphone cuts: a foreground product tease, a top-down lifestyle composition, a low pickup detail, a low-angle fashion portrait, a walking hand-and-bag detail, a medium creator portrait, a full outfit walk, and a final hero moment mid-stride. Use only carrying methods and attachments proven by image2; keep the same bag realistically scaled and unobstructed, with credible weight, gravity, handle tension, and hardware movement. Speak this English copy once in a natural creator voice: “This bag looked good, but I wanted to see it move. Up close, I notice the shape and finish. Here it is carried—what the photo couldn’t show.” Preserve subtle handheld movement, occasional natural motion blur, realistic focus changes, restrained color, and street ambience. Do not redesign, recolor, resize, duplicate, or merge the bag with hands or clothing. No text overlay, subtitle, filter, artificial transition, generated music, CTA, watermark, or UI.',
      zh: '使用 image1 作为唯一的人物身份与身形参考，使用 image2 作为唯一的手袋身份参考。生成一支潮流街拍风格的 13 秒、9:16 竖屏时尚 UGC 视频，场景位于优雅的欧洲城市街道，包含石板路、中性石材建筑、自然日光和真实阴影。严格保留人物的脸部身份、黑色长发、肤色、身体比例、红色上衣、浅色半裙、棕色长靴、首饰和自然动作；忽略人物源图中无关的棕色手袋。画面中始终只有 image2 的同一只黑白菱格手袋，并在所有镜头中保持源图所示的轮廓、比例、皮革材质、绗缝、黑色环形手柄、链条、五金、黑色角部拼片和 Logo 位置不变。使用每段约 1–2 秒的快速手机镜头：前景商品引子、俯拍生活场景、低机位拾取细节、低角度时尚肖像、行走中的手部与包袋细节、中景人物展示、全身穿搭步行和以迈步姿态结束的最终英雄镜头。只使用 image2 已证明的携带方式与附件；同一只包保持真实比例和完整可见，体现可信重量、重力、提手张力和五金运动。用自然创作者语气完整说一次英文：“This bag looked good, but I wanted to see it move. Up close, I notice the shape and finish. Here it is carried—what the photo couldn’t show.” 保留轻微手持运动、偶发自然动态模糊、真实对焦变化、克制色彩和街道环境声。禁止重新设计、改色、缩放、复制手袋或让手袋与手部、服装融合；不要添加文字、字幕、滤镜、人工转场、生成音乐、CTA、水印或 UI。',
    },
    referenceImages: [
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/b2032fa5-bab6-4695-8656-745d4e642a01.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original street-style creator identity and body reference',
          zh: '原始街头风创作者身份与身形参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/092c28ae-e430-450b-bfc8-19d77e4f3297.webp',
        slot: 'product',
        label: {
          en: 'Product',
          zh: '商品',
        },
        alt: {
          en: 'Original white-and-black quilted handbag product reference',
          zh: '原始黑白菱格手袋商品参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '13',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '480P',
      generateAudio: true,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '480p',
    outputSize: '496 × 864',
    createdAt: '2026-07-29',
    sourceProjectId: '1f2776a1-f223-4767-8d07-beb80f763027',
    sourceTaskId: '26ac0706-5b46-4058-bdb3-1d29f95585aa',
  },
  'case-02': {
    skillId: 'ugc-bag-unboxing',
    prompt: {
      en: 'Use image1 as the only creator identity and body reference and image2 as the only handbag identity reference. Create one complete 8-second vertical 9:16 creator-led handbag UGC reveal, captured like spontaneous flagship-phone footage in a lived-in room with daylight. Preserve the creator’s exact face, long black hair, skin tone, body proportions, red top, pale skirt, jewelry, hands, and natural movement. Ignore the unrelated brown handbag visible in the creator image. Preserve exactly one white-and-black quilted handbag from image2 with its photographed silhouette, proportions, leather response, stitching, black looped handles, chain, hardware, corner panel, and logo placement unchanged in every frame. Begin with the creator opening a plain unbranded white presentation box, reveal and remove the sole handbag once, then leave the opened box visibly empty. Intercut a direct-to-camera hook, the box action, a complete front-facing bag view, ordinary hand contact showing material response, connected hardware detail, and a natural carry payoff using only attachments and carrying methods proven by image2. Keep the bag realistically scaled with credible weight, gravity, handle tension, and garment contact. Speak this English copy once in a natural conversational voice: “I wanted to see this Cambon Bowler in person. Up close, I notice the shape. Here it is carried.” Use ordinary-speed action, clean hard cuts, subtle handheld drift, brief focus and exposure settling, mild phone grain, imperfect framing, real shadows, quiet room tone, and product-handling sound. Do not invent an interior pocket, closure, strap, attachment, logo, second bag, or branded packaging. No beauty smoothing, morph, dissolve, digital zoom, subtitle, caption, sticker, CTA, watermark, UI, or new text.',
      zh: '使用 image1 作为唯一的人物身份与身形参考，使用 image2 作为唯一的手袋身份参考。生成一支完整的 8 秒、9:16 竖屏创作者手袋 UGC 开箱展示视频，像在有自然日光的真实居家空间里用旗舰手机随手拍摄。严格保留人物的脸部身份、黑色长发、肤色、身体比例、红色上衣、浅色半裙、首饰、手部和自然动作；忽略人物源图中无关的棕色手袋。画面中始终只有 image2 的同一只黑白菱格手袋，并在所有帧中保持源图所示的轮廓、比例、皮革受力、绗缝、黑色环形手柄、链条、五金、黑色角部拼片和 Logo 位置不变。开场由人物打开一个无品牌的白色展示盒，只展示并取出唯一一只手袋一次，取出后已打开的盒子保持可见且为空。用干净硬切穿插对镜开场、开盒动作、完整正面包袋、以普通触摸展示材质受力、与整体结构相连的五金细节，以及只使用 image2 已证明附件与携带方式的自然上身效果。手袋保持真实比例，并体现可信重量、重力、提手张力和与服装的接触。用自然对话语气完整说一次英文：“I wanted to see this Cambon Bowler in person. Up close, I notice the shape. Here it is carried.” 使用正常速度动作、轻微手持漂移、短暂对焦与曝光调整、轻微手机颗粒、不完美构图、真实阴影、安静室内底噪和商品操作声。不要虚构内袋、开合、肩带、附件、Logo、第二只手袋或带品牌包装；也不要使用磨皮、变形、溶解、数字变焦、字幕、贴纸、CTA、水印、UI 或任何新文字。',
    },
    referenceImages: [
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/b2032fa5-bab6-4695-8656-745d4e642a01.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original handbag creator identity and body reference',
          zh: '原始手袋创作者身份与身形参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/092c28ae-e430-450b-bfc8-19d77e4f3297.webp',
        slot: 'product',
        label: {
          en: 'Product',
          zh: '商品',
        },
        alt: {
          en: 'Original white-and-black quilted handbag product reference',
          zh: '原始黑白菱格手袋商品参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '8',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '480P',
      generateAudio: true,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '480p',
    outputSize: '496 × 864',
    createdAt: '2026-07-29',
    sourceProjectId: '1f2776a1-f223-4767-8d07-beb80f763027',
    sourceTaskId: '1fcff376-ffa6-4818-9105-41dc389ae94a',
  },
  makeup: {
    skillId: 'ugc-beauty-skincare',
    prompt: {
      en: 'Use image1 as the only creator identity reference and image2 as the only product identity reference. Create one authentic 5-second vertical 9:16 phone-shot beauty UGC clip in a natural indoor setting. Preserve the creator’s exact face, hair, skin tone, hands, clothing, and body proportions. Preserve exactly one Dermocracy Soothing Azelaic Serum 10% bottle with its brown glass body, white label, black ribbed dropper cap, green accent, proportions, materials, and readable source-proven label layout. In one continuous ordinary-speed action, the creator brings the closed bottle into view, turns the front label toward the camera, lightly points to the bottle, and finishes with a natural product-forward reaction. Keep the product closed because the source images do not prove an opening, dispensing, dose, or application state. Use subtle handheld movement, real contact shadows, quick phone autofocus, quiet room tone, and natural product-handling sound. Do not duplicate or redesign the product, invent packaging or claims, change the creator’s identity, add subtitles, captions, stickers, CTA, watermark, UI, or new text.',
      zh: '使用 image1 作为唯一的人物身份参考，使用 image2 作为唯一的商品身份参考。生成一支自然真实的 5 秒、9:16 竖屏美妆 UGC 手机视频，场景为真实室内环境。严格保留人物的脸部身份、发型、肤色、手部、衣着和身体比例；画面中始终只有一瓶 Dermocracy Soothing Azelaic Serum 10% 壬二酸精华，并严格保留棕色玻璃瓶、白色标签、黑色竖纹滴管盖、绿色装饰条、瓶身比例、材质和源图中可辨认的标签排版。用一个普通人速度的连续动作完成：人物将闭合的精华瓶带入画面，把正面标签转向镜头，轻指瓶身，最后给出自然且以商品为中心的反应。由于源图没有证明开启、取液、剂量或上脸状态，商品全程保持闭合。保留轻微手持晃动、真实接触阴影、短暂手机自动对焦、安静室内底噪和自然商品操作声。禁止复制或重绘商品、虚构包装或功效、改变人物身份，也不要添加字幕、贴纸、CTA、水印、UI 或任何新文字。',
    },
    referenceImages: [
      {
        src: 'https://251000800.vod2.myqcloud.com/1a168d62vodcq251000800/f5c1240a5001834812920011422/aigcImageGenFile.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original creator identity reference',
          zh: '原始创作者身份参考图',
        },
      },
      {
        src: 'https://251000800.vod2.myqcloud.com/1a168d62vodcq251000800/0440e9b75001834812407806801/aigcImageGenFile.png',
        slot: 'product',
        label: {
          en: 'Product',
          zh: '商品',
        },
        alt: {
          en: 'Original Dermocracy serum product reference',
          zh: '原始 Dermocracy 精华商品参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'veo',
      videoDuration: '5',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      veoQuality: 'quality',
      generateAudio: true,
    },
    modelLabel: 'GV Omni',
    resolution: '720p',
    outputSize: '720 × 1280',
    createdAt: '2026-07-22',
    sourceProjectId: '85601a75-9248-408a-b1f7-dc87b189fa8b',
    sourceTaskId: '707b87ac-a916-4fc4-a616-24ccf3163409',
  },
  outfit: {
    skillId: 'ugc-try-on',
    prompt: {
      en: 'Use image1 as the only creator identity, supported body, room, and lighting reference. Use image2 as the only authority for the selected cream pleated dress. Create an 8-second vertical 9:16 creator-led get-ready-with-me video as one continuous iPhone front-camera take in a lived-in bedroom with soft daylight, slight handheld movement, natural HDR, real skin tones, and no color grading. Preserve the creator’s exact face, long dark-brown wavy hair, body proportions, hands, and natural movement. Preserve the dress’s thin straps, scoop neckline, fitted pleated bodice, gathered waist treatment, asymmetric layered ruffles, pleated texture, cream color, and floor length in every frame. The creator walks into frame already wearing and adjusting the fully settled dress, begins speaking to camera, reacts when a friend briefly enters from the side, pushes him back out, then returns to the viewer, steps back to show the complete look, and finishes with a confident pose. Speak this English script once in order: “Okay, I’m getting ready and I don’t know if this outfit is crazy or— Hey— no, get out! Anyway… I kinda love it. It’s a little chaotic… But it works. I’m wearing this.” Keep the interruption playful and natural. Do not animate dressing, show half-worn clothing, invent another garment, morph, dissolve, split the screen, duplicate the creator, add captions, CTA, watermark, UI, or new text.',
      zh: '使用 image1 作为唯一的人物身份、可见身形、房间与光线参考；使用 image2 作为米白色褶皱礼服的唯一依据。生成一支 8 秒、9:16 竖屏的创作者 GRWM 视频，使用 iPhone 前置镜头在真实卧室中一镜到底拍摄，保留柔和自然日光、轻微手持晃动、自然 HDR、真实肤色且不做调色。严格保留人物的脸部身份、深棕色长卷发、身体比例、手部和自然动作；礼服在所有帧中保持细肩带、圆弧领口、贴身褶皱上身、腰部聚拢结构、不对称层叠荷叶边、褶皱纹理、米白颜色和及地长度。人物已经穿好完整礼服并边整理边走入画面，对镜开场；朋友从侧面短暂闯入时，她自然地把对方推出画面，然后继续面对镜头，后退展示完整穿搭并用自信姿势结束。按顺序用自然英语说一次：“Okay, I’m getting ready and I don’t know if this outfit is crazy or— Hey— no, get out! Anyway… I kinda love it. It’s a little chaotic… But it works. I’m wearing this.” 互动保持轻松自然。禁止展示穿衣过程或半穿状态，禁止虚构其他服装、变形、溶解、分屏、复制人物，也不要添加字幕、CTA、水印、UI 或任何新文字。',
    },
    referenceImages: [
      {
        src: 'https://251000800.vod2.myqcloud.com/1a168d62vodcq251000800/320f2d7e5001834813126655708/aigcImageGenFile.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original creator identity and bedroom-lighting reference',
          zh: '原始创作者身份与卧室光线参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/9d6c08d9-8a30-4c80-a1f8-15d42ba69476.png',
        slot: 'product',
        label: {
          en: 'Outfit',
          zh: '穿搭',
        },
        alt: {
          en: 'Original cream pleated asymmetric dress reference',
          zh: '原始米白色褶皱不对称礼服参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '8',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '480P',
      generateAudio: true,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '480p',
    outputSize: '496 × 864',
    createdAt: '2026-07-29',
    sourceProjectId: 'f23c3df4-fdee-4283-a956-95a18c61ae37',
    sourceTaskId: '9fd4c3dd-b888-48ff-aaba-f2b9aafa1bf7',
  },
  'case-03': {
    skillId: 'ugc-try-on',
    prompt: {
      en: 'Use image1 as the only creator identity, supported body, room, and lighting reference. Use image2 as the only authority for the complete selected outfit. Create an 8-second vertical 9:16 creator-led virtual try-on filmed like spontaneous flagship-phone footage at home. Preserve the creator’s exact face, long dark-brown wavy hair, skin tone, body proportions, hands, and natural movement. Preserve the complete three-piece look from image2 without substitution or invention: the white cropped T-shirt with burgundy star graphics, knee-length camouflage wide shorts, and deep-red furry boots. Use three concise phases: a brief waist-up creator hook, one clean hard cut to the already settled full look for a readable front and quarter-turn fit check, then a medium closing reaction. Keep ordinary 1× motion, subtle handheld drift, daylight, short phone autofocus and exposure settling, real shadows, quiet room tone, and restrained fabric and footstep sounds. Do not animate dressing, show half-worn clothes, duplicate the person or outfit, morph, dissolve, spin, speed-ramp, digitally zoom, add speech or music, or introduce captions, CTA, watermark, UI, or new text. Identity, anatomy, garment graphics, camouflage pattern, hems, materials, colors, and footwear must remain stable in every frame.',
      zh: '使用 image1 作为唯一的人物身份、可见身形、房间与光线参考；使用 image2 作为完整选定穿搭的唯一依据。生成一支 8 秒、9:16 竖屏的创作者虚拟试穿视频，像在家中用旗舰手机自然随手拍摄。严格保留人物的脸部身份、深棕色长卷发、肤色、身体比例、手部和自然动作；严格保留 image2 中完整的三件套穿搭，不替换也不虚构：带酒红色星形图案的白色短款 T 恤、及膝迷彩宽松短裤和深红色毛绒长靴。视频只使用三个简洁阶段：短暂的半身人物开场、一次干净硬切后直接展示已经穿戴完整的全身正面与四分之一侧身效果，最后回到中景人物反应。保持正常 1 倍速动作、轻微手持漂移、自然日光、短暂手机自动对焦与曝光调整、真实阴影、安静室内底噪，以及克制的布料和脚步声。禁止展示穿衣过程或半穿状态，禁止复制人物或服装、变形、溶解、旋转、变速、数字变焦、口播或音乐，也不要添加字幕、CTA、水印、UI 或任何新文字。人物身份、人体结构、服装图案、迷彩纹理、下摆、材质、颜色和鞋履必须在所有帧中保持稳定。',
    },
    referenceImages: [
      {
        src: 'https://251000800.vod2.myqcloud.com/1a168d62vodcq251000800/320f2d7e5001834813126655708/aigcImageGenFile.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original creator identity, room, and lighting reference',
          zh: '原始创作者身份、房间与光线参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/99a3ea79-c838-4d66-8a01-ed2eed6ef617.png',
        slot: 'product',
        label: {
          en: 'Outfit',
          zh: '穿搭',
        },
        alt: {
          en: 'Original complete star, camouflage, and red-boots outfit reference',
          zh: '原始星形上衣、迷彩短裤与红色长靴完整穿搭参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '8',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '480P',
      generateAudio: false,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '480p',
    outputSize: '496 × 864',
    createdAt: '2026-07-26',
    sourceProjectId: 'f23c3df4-fdee-4283-a956-95a18c61ae37',
    sourceTaskId: '423282c1-0d20-4711-b032-890533db7392',
  },
  'case-04': {
    skillId: 'ugc-try-on',
    prompt: {
      en: 'Use image1 as the only creator identity, supported body, and base-clothing reference. Use image2 as the only authority for the selected cream pleated dress. Create a 12-second vertical 9:16 creator-led virtual try-on filmed like spontaneous flagship-phone footage in one naturally lit dressing space. Preserve the creator’s exact face, long dark-brown hair, skin tone, body proportions, hands, and natural movement. Preserve the dress’s thin straps, scoop neckline, fitted pleated bodice, gathered waist treatment, asymmetric layered ruffles, pleated texture, cream color, and floor length in every frame. Begin with the creator wearing her original black camisole and black drawstring pants while holding the complete dress toward the viewer. Use a clean hard cut to the already fully worn dress, then show her smoothing the upper hem, checking the neckline, turning to a quarter view, taking a natural full-body step, and finishing with a satisfied reaction and a reach toward the phone. Keep ordinary 1× movement, mild phone grain, subtle handheld drift, brief focus and exposure settling, real shadows, quiet room tone, and restrained fabric, garment-handling, and footstep sounds. Do not animate dressing, show a half-worn dress, retain the black base clothing after the change, invent accessories or another garment, morph, dissolve, spin, speed-ramp, digitally zoom, duplicate the creator, add speech or music, or introduce captions, CTA, watermark, UI, or new text.',
      zh: '使用 image1 作为唯一的人物身份、可见身形与原始基础穿搭参考；使用 image2 作为米白色褶皱礼服的唯一依据。生成一支 12 秒、9:16 竖屏的创作者虚拟试穿视频，像在同一个自然采光的更衣空间里用旗舰手机随手拍摄。严格保留人物的脸部身份、深棕色长发、肤色、身体比例、手部和自然动作；礼服在所有帧中保持细肩带、圆弧领口、贴身褶皱上身、腰部聚拢结构、不对称层叠荷叶边、褶皱纹理、米白颜色和及地长度。开场时人物穿着原始黑色吊带背心和黑色抽绳长裤，向镜头完整展示手中的礼服；使用一次干净硬切，直接切到已经完整穿好的礼服，随后展示整理上沿、检查领口、四分之一侧身、自然走一步的全身效果，最后以满意反应和伸手触碰手机结束。保持正常 1 倍速动作、轻微手机颗粒、细微手持漂移、短暂对焦与曝光调整、真实阴影、安静室内底噪，以及克制的布料、拿取衣物和脚步声。禁止展示穿衣过程或半穿礼服，换装后不得残留黑色基础穿搭，禁止虚构配饰或其他服装、变形、溶解、旋转、变速、数字变焦、复制人物、口播或音乐，也不要添加字幕、CTA、水印、UI 或任何新文字。',
    },
    referenceImages: [
      {
        src: 'https://251000800.vod2.myqcloud.com/1a168d62vodcq251000800/f5c1240a5001834812920011422/aigcImageGenFile.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original creator identity, body, and base-clothing reference',
          zh: '原始创作者身份、身形与基础穿搭参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/9d6c08d9-8a30-4c80-a1f8-15d42ba69476.png',
        slot: 'product',
        label: {
          en: 'Outfit',
          zh: '穿搭',
        },
        alt: {
          en: 'Original cream pleated asymmetric dress reference',
          zh: '原始米白色褶皱不对称礼服参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '12',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '720P',
      generateAudio: true,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '720p',
    outputSize: '720 × 1280',
    createdAt: '2026-07-27',
    sourceProjectId: 'f23c3df4-fdee-4283-a956-95a18c61ae37',
    sourceTaskId: 'a2189479-80cb-434f-aefb-d0ec9ec9469d',
  },
  'case-06': {
    skillId: 'ugc-beauty-skincare',
    prompt: {
      en: 'Use image1 as the only creator identity reference and image2 as the only product identity reference. Create one complete 12-second vertical 9:16 creator-led beauty UGC recommendation, captured like spontaneous flagship-phone footage. Preserve the creator’s exact face, hair, skin tone, body proportions, clothing, jewelry, hands, and handedness. Preserve exactly one source product: the same raspberry-colored Rhode Peptide Lip Tint tube, with its photographed silhouette, proportions, material, cap, colors, logo, and label layout unchanged in every frame. Intercut lively direct-to-camera speaking, natural closed-product handling, a clear front-label close-up, and a credible personal reaction using ordinary-speed motion and clean hard cuts. Because the original product source only proves the closed tube, do not open, squeeze, dispense, swatch, or apply it, and do not invent a shade result, formula appearance, dose, package, efficacy claim, or second SKU. Speak this Mandarin copy once in a natural conversational voice: “刷头很好用，一次就能看出效果。质地很轻盈，用后看起来很自然，我日常会很愿意用它。” Keep lip sync natural whenever the mouth is visible; product close-ups may continue under the same uninterrupted voice. Preserve natural phone sharpness, subtle handheld movement, short autofocus and exposure settling, individual hair strands, fabric texture, real shadows, quiet room tone, and product-handling sound. No beauty smoothing, morph, dissolve, digital zoom, duplicate product, anatomy drift, subtitle, caption, sticker, CTA, watermark, UI, or new text.',
      zh: '使用 image1 作为唯一的人物身份参考，使用 image2 作为唯一的商品身份参考。生成一支完整的 12 秒、9:16 竖屏美妆 UGC 推荐视频，像创作者用旗舰手机自然随手拍摄。严格保留人物的脸部身份、发型、肤色、身体比例、衣着、首饰、手部和惯用手；画面中始终只有一支源图中的商品：同一支莓红色 Rhode Peptide Lip Tint 唇彩管，并在所有帧中保持源图所示的轮廓、比例、材质、瓶盖、颜色、Logo 与标签排版不变。用正常速度动作和干净硬切，生动穿插对镜口播、自然展示闭合商品、正面标签近景和可信的个人反应。由于原始商品图只证明闭合状态，不要打开、挤压、取液、试色或上唇，也不要虚构色号效果、质地、剂量、包装、功效或第二件商品。用自然对话语气完整说一次：“刷头很好用，一次就能看出效果。质地很轻盈，用后看起来很自然，我日常会很愿意用它。” 嘴部可见时保持自然口型同步；商品近景期间由同一段声音连续覆盖。保留自然手机锐度、轻微手持晃动、短暂自动对焦和曝光调整、清晰发丝与衣料纹理、真实阴影、安静室内底噪和商品操作声。禁止磨皮、变形、溶解、数字变焦、商品复制、人体漂移，也不要添加字幕、贴纸、CTA、水印、UI 或任何新文字。',
    },
    referenceImages: [
      {
        src: 'https://251000800.vod2.myqcloud.com/1a168d62vodcq251000800/320f2d7e5001834813126655708/aigcImageGenFile.png',
        slot: 'person',
        label: {
          en: 'Person',
          zh: '人物',
        },
        alt: {
          en: 'Original creator identity reference',
          zh: '原始创作者身份参考图',
        },
      },
      {
        src: 'https://img.dobidobi.cn/materials/76855434-9c51-44aa-a70c-fda8b50228c2/general/00425415-7987-4430-9f65-5ab70b665644.jpg',
        slot: 'product',
        label: {
          en: 'Product',
          zh: '商品',
        },
        alt: {
          en: 'Original Rhode Peptide Lip Tint product reference',
          zh: '原始 Rhode Peptide Lip Tint 唇彩商品参考图',
        },
      },
    ],
    videoSettings: {
      videoProvider: 'seedance',
      videoDuration: '12',
      videoAspectRatio: '9:16',
      videoSubMode: 'universal_ref',
      seedanceModel: 'seedance-2.0',
      seedanceResolution: '720P',
      generateAudio: true,
    },
    modelLabel: 'Seedance 2.0',
    resolution: '720p',
    outputSize: '720 × 1280',
    createdAt: '2026-07-25',
    sourceProjectId: '85601a75-9248-408a-b1f7-dc87b189fa8b',
    sourceTaskId: '0c8ab69b-9ba3-42fe-9d70-9c1d24331057',
  },
} as const;
